import comp from "./UseTemplateModal";
export default comp;
